import { render, staticRenderFns } from "./TablePerimeterSecurityAnalytics.vue?vue&type=template&id=13cdce19"
import script from "./TablePerimeterSecurityAnalytics.vue?vue&type=script&lang=js"
export * from "./TablePerimeterSecurityAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports